import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, ShieldCheckIcon, FileTextIcon } from 'lucide-react';
export function LegalInformation() {
  return <section className="w-full py-20 lg:py-24 bg-white relative overflow-hidden" data-id="element-289">
      <div className="absolute inset-0" data-id="element-290">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-aqua/10 rounded-full blur-3xl" data-id="element-291" />
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-3xl" data-id="element-292" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 sm:mb-16 px-4" data-id="element-294">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/10 rounded-full mb-4" data-id="element-295">
            <ScaleIcon className="w-4 h-4 text-brand-gold" data-id="element-296" />
            <span className="text-brand-gold font-semibold text-xs sm:text-sm uppercase tracking-wider" data-id="element-297">
              Legal & Professional
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy mb-4 sm:mb-6" data-id="element-298">
            Professional Medical{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-gold" data-id="element-299">
              Practice
            </span>
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto px-4" data-id="element-300">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gradient-to-br from-white to-brand-aqua/5 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 shadow-xl border border-brand-gold/10" data-id="element-301">
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-302">
              This medical practice operates under{' '}
              <strong data-id="element-303">Mark Joy, MD PLLC</strong>, a New York Professional
              Limited Liability Company authorized to practice medicine.
            </p>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed" data-id="element-304">
              All consultations are conducted in accordance with applicable
              medical and ethical standards.
            </p>

            <div className="mt-8 sm:mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-305">
              <div className="flex items-start gap-3" data-id="element-306">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-gold/10 rounded-full flex items-center justify-center" data-id="element-307">
                  <FileTextIcon className="w-5 h-5 text-brand-gold" data-id="element-308" />
                </div>
                <div data-id="element-309">
                  <p className="font-semibold text-brand-navy mb-1 text-sm sm:text-base" data-id="element-310">
                    Legal Entity
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600" data-id="element-311">
                    Mark Joy, MD PLLC
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-312">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-gold/10 rounded-full flex items-center justify-center" data-id="element-313">
                  <ScaleIcon className="w-5 h-5 text-brand-gold" data-id="element-314" />
                </div>
                <div data-id="element-315">
                  <p className="font-semibold text-brand-navy mb-1 text-sm sm:text-base" data-id="element-316">
                    Entity Type
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600" data-id="element-317">NY PLLC</p>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-318">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-gold/10 rounded-full flex items-center justify-center" data-id="element-319">
                  <ShieldCheckIcon className="w-5 h-5 text-brand-gold" data-id="element-320" />
                </div>
                <div data-id="element-321">
                  <p className="font-semibold text-brand-navy mb-1 text-sm sm:text-base" data-id="element-322">
                    Authorized Practice
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600" data-id="element-323">Medicine</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}